import { z } from 'zod';
export var EatingCommitmentHealthyFoodEnum = {
    FRUITS: 'FRUITS',
    VEGETABLES: 'VEGETABLES',
    LEAN_MEATS: 'LEAN_MEATS',
    GRAINS: 'GRAINS',
    HEALTHY_FATS: 'HEALTHY_FATS',
    OTHER: 'OTHER'
};
export var EatingCommitmentUnhealthyFoodEnum = {
    SODA: 'SODA',
    TAKEOUT: 'TAKEOUT',
    DESSERTS: 'DESSERTS',
    JUNK_FOOD: 'JUNK_FOOD',
    CANDY: 'CANDY',
    OTHER: 'OTHER'
};
export var EatingCommitment = z.object({
    increase: z.nativeEnum(EatingCommitmentHealthyFoodEnum),
    increaseOther: z.string().optional(),
    decrease: z.nativeEnum(EatingCommitmentUnhealthyFoodEnum),
    decreaseOther: z.string().optional()
}).prefault({
    increase: 'FRUITS',
    decrease: 'SODA'
});
